/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-27 19:52:57
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-23 16:15:13
 * @FilePath: /knit-web/src/locale/en-US/tool.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  tool: {
    publishAsTool: 'Publish as Tool',
    publish: 'Publish',
    name: 'Name',
    description: 'Description',
    avatar: 'Avatar',
    iconPlaceholder: 'Emoji',
    namePlaceholder: 'Enter name',
    nameRequired: 'Name is required',
    descriptionRequired: 'Description is required',
    category: 'Category',
    selectCategory: 'Select category',
    categoryRequired: 'Category is required',
    version: 'Version',
    toolVersion: 'Tool Version',
    mustTestRun: 'Must test run before publishing',
    submitToMarketplace: 'Submit to Marketplace',
    creditsPerUse: 'Get 100 Credits per use!',
    submitAsTemplateEarn: 'Submit as template tool to start earning.',
    selectFromWorkflowLogs: 'Select from workflow logs',
    logInput: 'Log Input',
    workflowNamePlaceholder: 'Workflow Name',
    workflowDescPlaceholder: 'Workflow Description',
    inputDescPlaceholder: "Description of the variable's meaning",
    toolType: 'Tool Type',
    toolInput: 'Tool Input',
    toolOutput: 'Tool Output',
    testInput: 'Input Example',
    tags: 'Tags',
    author: 'Author',
    changeLog: 'Change Log',
    required: 'Required',
    optional: 'Optional',
    requiredLabel: 'Required',
    template: 'Template',
    subFlow: 'SubFlow',
    useTemplate: 'Use Template',
    templateDesc:
      'Template tools can be copied as a new workflow or added to an existing workflow.',
    useTemplateConfirmTitle: 'Use Template Confirm',
    useTemplateConfirmContent:
      'Are you sure you want to use the template "{name}"?',
    addToWorkflow: 'Add to workflow',
    eachCopyEarn: 'Each copy can earn 100 credits',
    officialDoc: 'Official Documentation',
    validateIssues: 'Validation Issues',
    noTestRun: 'Workflow not tested',
    goToTestRun: 'Test Run',
    publishSuccess: 'Published Successfully',
    backToStudio: 'Back to Studio',
    manageInTools: 'Manage Tools',
    inputName: 'Name',
    inputMethod: 'Method',
    inputDesc: 'Description',
    outputName: 'Name',
    outputDesc: 'Description',
    versionPlaceholder: 'Default v0.1.0',
    setting: 'Setting',
    frontend: 'Frontend Input',
    updateTool: 'Update Tool',
    tool: 'Tool',
    selectTool: 'Select Tool',
    selectToolPlaceholder: 'Select a tool',
    selectToolFirst: 'Please select a tool to update first',
    latestPublished: 'Latest Published',
    selectToolToUpdate: 'Select a tool to update',
    changeLogPlaceholder: 'Enter change log (optional)',
    versionError: 'Version must be greater than current version ({current})',
    updateSuccess: 'Updated successfully',
    manageTools: 'Manage in Tools',
    selectPublishType: 'Select Publish Type',
    createNewTool: 'Create New Tool',
    createNewToolDesc: 'Create a brand new tool',
    updateExistingTool: 'Update Existing Tool',
    updateExistingToolDesc: 'Create a new version for an existing tool',
    noToolsAvailable: 'No tools available',
    workspaceRequired: 'Workspace information required',
    fetchToolsFailed: 'Failed to fetch tools list',
    selectTags: 'Please select tags',
    useRunInput: 'Use run input',
    allTags: 'All Tags',
    searchPlaceholder: 'Search tool name',
    noToolsFound: 'No tools found',
    noDescription: 'No description',
    updatedAt: 'Updated at',
    usageCount: 'usages',
    usageCountLabel: 'Usage Count',
    unpublish: 'Unpublish Version',
    unpublishConfirmTitle: 'Confirm Unpublish',
    unpublishConfirmContent:
      'Are you sure you want to unpublish the current version of tool "{name}"?',
    unpublishSuccess: 'Unpublished successfully',
    unpublishFailed: 'Unpublish failed',
    fetchFailed: 'Load failed',
    status: {
      normal: 'Normal',
      disabled: 'Disabled',
    },
    latestVersion: 'Latest Version',
    publishedVersion: 'Published Version',
    publishFailed: 'Publish failed',
    versionHistory: 'Version History',
    manage: 'Manage',
    delete: 'Delete',
    deleteConfirmTitle: 'Confirm Delete',
    deleteConfirmContent: 'Are you sure you want to delete the tool "{name}"?',
    category: 'Category',
    versionNum: 'Version',
    createdAt: 'Created at',
    manifest: 'Manifest',
    toolUuid: 'Tool UUID',
    tenantUuid: 'Tenant UUID',
    workspaceUuid: 'Workspace UUID',
    sourceWorkflowUuid: 'Source Workflow UUID',
    sourceWorkflowVersionNum: 'Source Workflow Version',
    workflowUuid: 'Workflow UUID',
    versionStatus: {
      draft: 'Draft',
      pending: 'Pending',
      published: 'Published',
      disabled: 'Disabled',
    },
    type: {
      workflow_template: 'Workflow Template',
      workflow: 'Workflow',
    },
    currentVersionInfo: 'Current Version Info',
    toolInfo: 'Tool Info',
    statusLabel: 'Status',
    typeLabel: 'Type',
    stateLabel: 'State',
  },
};
